import * as env from '@/common/utils/env'

const canAddListener
  = window.Soda && window.Soda.setBackPressListener && env.isAndroid

let listeners = []

export function addListener(callback) {
  if (!callback || !canAddListener) return

  if (!listeners.includes(callback)) {
    listeners.unshift(callback)
  }

  return {
    remove() {
      removeListener(callback)
    }
  }
}

export function removeListener(callback) {
  listeners = listeners.filter(it => it !== callback)
}

export function onceListener(callback) {
  if (!callback || !canAddListener) return
  const handler = function(...args) {
    removeListener(handler)
    return callback(...args)
  }

  listeners.unshift(handler)
  return {
    remove() {
      removeListener(handler)
    }
  }
}

export function uninit() {
  window.Soda && window.Soda.setBackPressListener && window.Soda.setBackPressListener(false)
}

export function init() {
  if (canAddListener) {
    window.Soda.setBackPressListener(true, function() {
      listeners.reduce((excuteNextHandler, handler) => {
        if (excuteNextHandler) {
          return handler()
        }
        return false
      }, true)
    })
  }
}

export default {
  init,
  uninit,
  addListener,
  removeListener,
  onceListener
}
